import { FC } from "react";
import "./loader.scss";
import { DotLoader, UnifyListIconLoader } from "@components/icons";

export const enum LoaderType {
  DotLoader = "DotLoader",
  Spinner = "Spinner",
}
interface LoaderProps {
  variant?: "full-screen" | "inline";
  type?: LoaderType;
  className?: string;
}

export const Loader: FC<LoaderProps> = ({ variant = "full-screen", className = "", type }) => {
  return type === LoaderType.Spinner ? (
    <div className={`spinner-loader ${className}`} />
  ) : (
    <div className={`loader-container ${variant} ${className}`}>
      {type === LoaderType.DotLoader ? <DotLoader color="#333" /> : <UnifyListIconLoader />}
    </div>
  );
};
